import dungeon from './dungeon/map.jsx';
import field from './field/map.jsx';
import ice from './ice/map.jsx';
import room from './room/map.jsx';
import sewer from './sewer/map.jsx';
import mountain from './mountain/map.jsx';
import jungle from './jungle/map.jsx';

export default {
    dungeon,
    field,
    ice,
    room,
    sewer,
    mountain,
    jungle
}